import { Component, inject, Input } from '@angular/core';
import { BasicForm } from '@shared/components/classes/basic.form';
import { RentalContract } from '@modules/universal-billing/contract/contract.interface';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { ContractService } from '@modules/universal-billing/contract/contract.service';
import { Observable } from 'rxjs';
import {
  ContactExceptionsFormComponent
} from '@modules/universal-billing/contract/components/contact-exceptions-form/contact-exceptions-form.component';
import { formatDate } from '@shared/utils/format-date';
import { ButtonModule } from '@primeng/button';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-contract-side-costs-form',
  standalone: true,
  imports: [
    ContactExceptionsFormComponent,
    ButtonModule,
    TranslatePipe
  ],
  templateUrl: './contract-side-costs-form.component.html',
  styleUrl: './contract-side-costs-form.component.scss'
})
export class ContractSideCostsFormComponent extends BasicForm<any>{

  @Input() contract: RentalContract;
  @Input() afterSuccess: Function;

  form: FormGroup = new FormGroup({
    sideCosts: new FormArray([]),
    billingPeriod: new FormControl(),
  });

  _defaultService: ContractService = inject(ContractService);

  get siteCostsArray(): FormArray {
    return this.form.get('sideCosts') as FormArray;
  }

  ngOnInit() {
    this.updateValue();
  }

  convertToRequestData(data: any): any {
    const siteCosts = [];
    data.sideCosts.forEach(sideCost => {
      if (sideCost.checked) {
        siteCosts.push({...sideCost, billingPeriodCode: data.billingPeriod});
      }
    })
    const res = { ... this.contract};
    res.sideCosts = siteCosts;
    return super.convertToRequestData(res);
  }

  submitAction(data: any): Observable<any> {
    return this._defaultService.put(data, this.contract.id);
  }
  updateValue() {
    let billingPeriod = null;
    this.contract.sideCosts.forEach(sideCost => {
      this.siteCostsArray.push(new FormGroup({
        utilityRateId: new FormControl(sideCost.utilityRateId, Validators.required),
        bookingDate: new FormControl(sideCost.bookingDate ? new Date(sideCost.bookingDate) : sideCost.bookingDate, Validators.required),
        checked: new FormControl(true, Validators.required),
      }));
      billingPeriod = sideCost.billingPeriodCode;
    })
    this.form.get('billingPeriod').setValue(billingPeriod);
  }
  afterSuccessSubmit(res: any) {
    this.afterSuccess(res.data, true);
    super.afterSuccessSubmit(res);
  }
}
